import React, {useState} from 'react';
import {Transition} from 'react-transition-group';
import Logo from './Logo';
import NewsletterMinimal from './NewsletterMinimal';

export const TRANSITION_DURATION = 400;

const TRANSITION_STYLES = {
	default: {
		transition: `opacity ${TRANSITION_DURATION}ms ease`,
	},
	entering: {
		opacity: 0,
	},
	entered: {
		opacity: 1,
	},
	exiting: {
		opacity: 0,
	},
	exited: {
		opacity: 0,
	},
};

const KLAVIYO_ID = process.env.GATSBY_KLAVIYO_LIST;

const Splash = () => {
	const [isLogoVisible, setIsLogoVisible] = useState(true);
	return (
		<section className="splash pf">
			<Transition
				mountOnEnter
				unmountOnExit
				appear
				in={isLogoVisible}
				timeout={TRANSITION_DURATION}>
				{status => (
					<div
						className="splash__logo-container pf df fdc jcc aic tc"
						style={{
							...TRANSITION_STYLES.default,
							...TRANSITION_STYLES[status],
						}}>
						<button
							className="logo splash__logo-button"
							onClick={() => setIsLogoVisible(false)}>
							<Logo className="splash__logo" />
						</button>
					</div>
				)}
			</Transition>
			<Transition
				mountOnEnter
				unmountOnExit
				appear
				in={!isLogoVisible}
				timeout={TRANSITION_DURATION}>
				{status => (
					<aside
						className="splash__content pa tr p2 df fdc jcc y"
						style={{
							...TRANSITION_STYLES.default,
							...TRANSITION_STYLES[status],
						}}>
						<p className="serif--xs serif--sm--md">
							Elegant, utilitarian homeware designed to please the
							eye, mouth, and hand.
						</p>
						<NewsletterMinimal
							className="mt4 mla tr newsletter"
							klaviyoListId={KLAVIYO_ID}
						/>
						<nav className="splash__links mt4 mla df fdc aie">
							<a
								href="mailto:inquiries@pasqueofficial.com"
								className="db link--underline serif--xs serif--sm--md tr">
								inquiries@pasqueofficial.com
							</a>
							<a
								href="https://www.instagram.com/pasqueofficial/"
								target="_blank"
								rel="noreferrer noopener"
								className="db link--underline serif--xs serif--sm--md tr">
								@pasqueofficial
							</a>
						</nav>
					</aside>
				)}
			</Transition>
		</section>
	);
};

export default Splash;
